import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=5a2c08f6&scoped=true"
import script from "./doc.vue?vue&type=script&lang=js"
export * from "./doc.vue?vue&type=script&lang=js"
import style0 from "./doc.vue?vue&type=style&index=0&id=5a2c08f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c08f6",
  null
  
)

export default component.exports